// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","name":"Welcome","hideInMenu":true,"parentId":"@@/global-layout","id":"1"},"2":{"path":"/login","name":"Login","layout":false,"id":"2"},"3":{"path":"/myCourses","name":"My Courses","parentId":"@@/global-layout","id":"3"},"4":{"path":"/Schedule","name":"Schedule","parentId":"@@/global-layout","id":"4"},"@@/global-layout":{"id":"@@/global-layout","path":"/","parentId":"ant-design-pro-layout","isLayout":true},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__welcome__index" */'@/pages/welcome/index.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "p__login__index" */'@/pages/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__myCourses__index" */'@/pages/myCourses/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__schedule__index" */'@/pages/schedule/index.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'/var/lib/jenkins/sit-workspace/workspace/prod-mxc-english-crm/src/layouts/index.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/var/lib/jenkins/sit-workspace/workspace/prod-mxc-english-crm/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
